import { Theme, css } from '@emotion/react';

export const button = ({ borderRadius }: Theme) => css`
  width: 100%;
  cursor: pointer;

  .apple-pay-button {
    display: inline-block;
    -webkit-appearance: -apple-pay-button;
  }

  @supports (-webkit-appearance: -apple-pay-button) {
    .apple-pay-button-with-text {
      border-radius: ${borderRadius.Pill};
      width: 100%;
      height: 48px;
      display: inline-block;
      -webkit-appearance: -apple-pay-button;
      -apple-pay-button-type: plain;
    }
    .apple-pay-button-with-text > * {
      display: none;
    }
    .apple-pay-button-black-with-text {
      -apple-pay-button-style: black;
    }
  }

  @supports not (-webkit-appearance: -apple-pay-button) {
    .apple-pay-button-with-text {
      --apple-pay-scale: 1; /* (height / 32) */
      display: inline-flex;
      justify-content: center;
      font-size: 12px;
      border-radius: ${borderRadius[100]};
      padding: 0px;
      box-sizing: border-box;
      min-width: 200px;
      width: 100%;
    }
    .apple-pay-button-black-with-text {
      background-color: black;
      color: white;
    }
    .apple-pay-button-with-text.apple-pay-button-black-with-text > .logo {
      background-image: -webkit-named-image(apple-pay-logo-white);
      background-color: black;
    }
    .apple-pay-button-with-text > .text {
      font-family: -apple-system;
      font-size: calc(1em * var(--apple-pay-scale));
      font-weight: 300;
      align-self: center;
      margin-right: calc(2px * var(--apple-pay-scale));
    }
    .apple-pay-button-with-text > .logo {
      width: calc(35px * var(--scale));
      height: 100%;
      background-size: 100% 60%;
      background-repeat: no-repeat;
      background-position: 0 50%;
      margin-left: calc(2px * var(--apple-pay-scale));
      border: none;
    }
  }
`;
